export { default as Statistics } from "./main";

import * as Anchors from "./anchors";
import { default as routes } from "./routes";
export default {
  Anchors,
  routes,
};
